import md5 from 'blueimp-md5';

import { AVATAR_SIZE, GRAVATAR_URL } from '@/utils/constants';

/**
 * Zwraca link do pobrania obrazka w wymiarach avataru
 *
 * @export
 * @param {string} email
 * @returns {string}
 */
export function gravatarUrl(email: string): string {
  return GRAVATAR_URL + md5(email.trim().toLowerCase()) + '?s=' + AVATAR_SIZE.width + '&d=mp';
}
